module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Outdated', {
    ref: "outdated"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.backVisible && _vm.isNavFocusMode) ? _c('div', {
    staticClass: "header__left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.back()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$utils.svg(require('./assets/img/left-arrow.svg')),
      "width": "30",
      "alt": "Back"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.navTitle) ? _c('h1', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.navTitle))]) : _vm._e(), _vm._v(" "), (!_vm.isNavFocusMode) ? _c('div', {
    staticClass: "site-header"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_c('img', {
    staticClass: "logo-domain-sm show-sm",
    attrs: {
      "src": require("./assets/domain-custom/base/logo-domain.png"),
      "srcset": ((_vm.images.logo1) + " 1x, " + (_vm.images.logo2) + " 2x"),
      "alt": _vm.$config.WEBSITE_NAME + 'Shop Logo'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-domain hide-sm",
    attrs: {
      "src": require("./assets/domain-custom/base/logo-domain-desktop.png"),
      "srcset": ((_vm.images.logo3) + " 1x, " + (_vm.images.logo4) + " 2x"),
      "alt": _vm.$config.WEBSITE_NAME + 'Shop Logo'
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showCartStatus) ? _c('cart-status-icon') : _vm._e(), _vm._v(" "), (!_vm.isNavFocusMode) ? _c('div', {
    staticClass: "main-navigation"
  }, [_c('a', {
    staticClass: "hamburger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showMenu()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('nav-menu-top', {
    staticClass: "hide-sm"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pull-right"
    }
  }, [_c('nav-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    on: {
      "hideMenu": function($event) {
        return _vm.hideMenu()
      }
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('site-footer', {
    staticClass: "hide-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer hide-sm"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "fl-left"
  }, [_vm._v("Copyright " + _vm._s(_vm.$config.WEBSITE_NAME) + " 2018, All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "fl-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('terms')
    }
  }, [_vm._v("Terms of service")]), _vm._v(" |\n        "), _c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('policy')
    }
  }, [_vm._v("Privacy Policy")])])])]), _vm._v(" "), _c('login-modal', {
    ref: "loginModal"
  }), _vm._v(" "), _c('vue-toast', {
    ref: "toast"
  }), _vm._v(" "), _c('vue-modal', {
    ref: "modal"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamburger__menu"
  }, [_c('span', {
    staticClass: "bread"
  }), _vm._v(" "), _c('span', {
    staticClass: "bread"
  }), _vm._v(" "), _c('span', {
    staticClass: "bread"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f390abee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1149
// module chunks = 1